/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  assertIsInstructionWithAccounts,
  containsBytes,
  fixEncoderSize,
  getBytesEncoder,
  SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_ACCOUNT,
  SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_INSTRUCTION,
  SOLANA_ERROR__PROGRAM_CLIENTS__UNRECOGNIZED_INSTRUCTION_TYPE,
  SolanaError,
  type Address,
  type ClientWithPayer,
  type ClientWithRpc,
  type ClientWithTransactionPlanning,
  type ClientWithTransactionSending,
  type GetAccountInfoApi,
  type GetMultipleAccountsApi,
  type Instruction,
  type InstructionWithData,
  type ReadonlyUint8Array,
} from '@solana/kit';
import {
  addSelfFetchFunctions,
  addSelfPlanAndSendFunctions,
  type SelfFetchFunctions,
  type SelfPlanAndSendFunctions,
} from '@solana/program-client-core';
import {
  getHookConfigCodec,
  type HookConfig,
  type HookConfigArgs,
} from '../accounts';
import {
  getAddCosignerInstructionAsync,
  getInitializeConfigInstructionAsync,
  getRemoveCosignerInstructionAsync,
  getSetAuthorityInstructionAsync,
  parseAddCosignerInstruction,
  parseInitializeConfigInstruction,
  parseRemoveCosignerInstruction,
  parseSetAuthorityInstruction,
  type AddCosignerAsyncInput,
  type InitializeConfigAsyncInput,
  type ParsedAddCosignerInstruction,
  type ParsedInitializeConfigInstruction,
  type ParsedRemoveCosignerInstruction,
  type ParsedSetAuthorityInstruction,
  type RemoveCosignerAsyncInput,
  type SetAuthorityAsyncInput,
} from '../instructions';

export const DOPPLER_LAUNCH_HOOK_V2_PROGRAM_ADDRESS =
  '7ZueM1Tef2QA5zrFtVJMDM8MFqkoeG8fog1mXPgmLGH1' as Address<'7ZueM1Tef2QA5zrFtVJMDM8MFqkoeG8fog1mXPgmLGH1'>;

export enum DopplerLaunchHookV2Account {
  HookConfig,
}

export function identifyDopplerLaunchHookV2Account(
  account: { data: ReadonlyUint8Array } | ReadonlyUint8Array,
): DopplerLaunchHookV2Account {
  const data = 'data' in account ? account.data : account;
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([137, 155, 101, 95, 138, 72, 8, 182]),
      ),
      0,
    )
  ) {
    return DopplerLaunchHookV2Account.HookConfig;
  }
  throw new SolanaError(
    SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_ACCOUNT,
    { accountData: data, programName: 'dopplerLaunchHookV2' },
  );
}

export enum DopplerLaunchHookV2Instruction {
  AddCosigner,
  InitializeConfig,
  RemoveCosigner,
  SetAuthority,
}

export function identifyDopplerLaunchHookV2Instruction(
  instruction: { data: ReadonlyUint8Array } | ReadonlyUint8Array,
): DopplerLaunchHookV2Instruction {
  const data = 'data' in instruction ? instruction.data : instruction;
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([17, 34, 183, 119, 202, 255, 218, 233]),
      ),
      0,
    )
  ) {
    return DopplerLaunchHookV2Instruction.AddCosigner;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([208, 127, 21, 1, 194, 190, 196, 70]),
      ),
      0,
    )
  ) {
    return DopplerLaunchHookV2Instruction.InitializeConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([174, 11, 171, 252, 179, 99, 220, 27]),
      ),
      0,
    )
  ) {
    return DopplerLaunchHookV2Instruction.RemoveCosigner;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([133, 250, 37, 21, 110, 163, 26, 121]),
      ),
      0,
    )
  ) {
    return DopplerLaunchHookV2Instruction.SetAuthority;
  }
  throw new SolanaError(
    SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_INSTRUCTION,
    { instructionData: data, programName: 'dopplerLaunchHookV2' },
  );
}

export type ParsedDopplerLaunchHookV2Instruction<
  TProgram extends string = '7ZueM1Tef2QA5zrFtVJMDM8MFqkoeG8fog1mXPgmLGH1',
> =
  | ({
      instructionType: DopplerLaunchHookV2Instruction.AddCosigner;
    } & ParsedAddCosignerInstruction<TProgram>)
  | ({
      instructionType: DopplerLaunchHookV2Instruction.InitializeConfig;
    } & ParsedInitializeConfigInstruction<TProgram>)
  | ({
      instructionType: DopplerLaunchHookV2Instruction.RemoveCosigner;
    } & ParsedRemoveCosignerInstruction<TProgram>)
  | ({
      instructionType: DopplerLaunchHookV2Instruction.SetAuthority;
    } & ParsedSetAuthorityInstruction<TProgram>);

export function parseDopplerLaunchHookV2Instruction<TProgram extends string>(
  instruction: Instruction<TProgram> & InstructionWithData<ReadonlyUint8Array>,
): ParsedDopplerLaunchHookV2Instruction<TProgram> {
  const instructionType = identifyDopplerLaunchHookV2Instruction(instruction);
  switch (instructionType) {
    case DopplerLaunchHookV2Instruction.AddCosigner: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: DopplerLaunchHookV2Instruction.AddCosigner,
        ...parseAddCosignerInstruction(instruction),
      };
    }
    case DopplerLaunchHookV2Instruction.InitializeConfig: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: DopplerLaunchHookV2Instruction.InitializeConfig,
        ...parseInitializeConfigInstruction(instruction),
      };
    }
    case DopplerLaunchHookV2Instruction.RemoveCosigner: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: DopplerLaunchHookV2Instruction.RemoveCosigner,
        ...parseRemoveCosignerInstruction(instruction),
      };
    }
    case DopplerLaunchHookV2Instruction.SetAuthority: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: DopplerLaunchHookV2Instruction.SetAuthority,
        ...parseSetAuthorityInstruction(instruction),
      };
    }
    default:
      throw new SolanaError(
        SOLANA_ERROR__PROGRAM_CLIENTS__UNRECOGNIZED_INSTRUCTION_TYPE,
        {
          instructionType: instructionType as string,
          programName: 'dopplerLaunchHookV2',
        },
      );
  }
}

export type DopplerLaunchHookV2Plugin = {
  accounts: DopplerLaunchHookV2PluginAccounts;
  instructions: DopplerLaunchHookV2PluginInstructions;
};

export type DopplerLaunchHookV2PluginAccounts = {
  hookConfig: ReturnType<typeof getHookConfigCodec> &
    SelfFetchFunctions<HookConfigArgs, HookConfig>;
};

export type DopplerLaunchHookV2PluginInstructions = {
  addCosigner: (
    input: AddCosignerAsyncInput,
  ) => ReturnType<typeof getAddCosignerInstructionAsync> &
    SelfPlanAndSendFunctions;
  initializeConfig: (
    input: MakeOptional<InitializeConfigAsyncInput, 'payer'>,
  ) => ReturnType<typeof getInitializeConfigInstructionAsync> &
    SelfPlanAndSendFunctions;
  removeCosigner: (
    input: RemoveCosignerAsyncInput,
  ) => ReturnType<typeof getRemoveCosignerInstructionAsync> &
    SelfPlanAndSendFunctions;
  setAuthority: (
    input: SetAuthorityAsyncInput,
  ) => ReturnType<typeof getSetAuthorityInstructionAsync> &
    SelfPlanAndSendFunctions;
};

export type DopplerLaunchHookV2PluginRequirements = ClientWithRpc<
  GetAccountInfoApi & GetMultipleAccountsApi
> &
  ClientWithPayer &
  ClientWithTransactionPlanning &
  ClientWithTransactionSending;

export function dopplerLaunchHookV2Program() {
  return <T extends DopplerLaunchHookV2PluginRequirements>(client: T) => {
    return {
      ...client,
      dopplerLaunchHookV2: <DopplerLaunchHookV2Plugin>{
        accounts: {
          hookConfig: addSelfFetchFunctions(client, getHookConfigCodec()),
        },
        instructions: {
          addCosigner: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getAddCosignerInstructionAsync(input),
            ),
          initializeConfig: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getInitializeConfigInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
          removeCosigner: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getRemoveCosignerInstructionAsync(input),
            ),
          setAuthority: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getSetAuthorityInstructionAsync(input),
            ),
        },
      },
    };
  };
}

type MakeOptional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;
